import request from 'src/utils/request';

export function syncLabels() {
  return request({
    url: `apps/mip/labels/sync`,
    method: 'post',
  });
}

export default {
  syncLabels,
};
